/**
 * Global style objects for MUI's `<GlobalStyles>`.
 *
 * Split into two exports on purpose. `App.tsx` returns `<PasswordProtect />`
 * before its `ThemeProvider`, so anything mounted inside the themed subtree
 * never reaches the password gate. `ROOT_TOKEN_STYLES` is therefore mounted
 * above that branch (MUI's GlobalStyles does not require a ThemeProvider
 * ancestor), while `BASE_GLOBAL_STYLES` stays exactly where it was.
 */
import { CSS_VARIABLES } from './cssVariables';
import { FONT_FAMILY } from './tokens';

/** The `--w-*` custom properties every SCSS file reads. Mount app-wide. */
export const ROOT_TOKEN_STYLES = {
  ':root': CSS_VARIABLES,
};

/**
 * Base element styles.
 *
 * The global `button { border-radius }` rule is gone. Measuring against the
 * *compiled* CSS (SCSS nesting means `&__close` never appears literally in
 * source, which an earlier source-level count got wrong) showed only four raw
 * button classes ever depended on it — `remove-tag-btn`,
 * `map-poi-popup__add-to-list`, `context-menu-item` and `password-button`. Each
 * now sets `var(--w-radius-md)` itself, so nothing changed visually and buttons
 * no longer get a radius by ambient inheritance.
 *
 * One leftover: the link color is the CSS keyword `black`, not
 * `--w-color-ink` (#141414). Changing it is a visual decision of its own.
 */
export const BASE_GLOBAL_STYLES = {
  body: {
    fontFamily: FONT_FAMILY,
    letterSpacing: '0.0225rem',
    backgroundColor: 'var(--w-color-page)',
  },
  /**
   * Action button inside a toast. Global because notistack renders toasts in a
   * portal at the document root, so there is no component stylesheet in scope.
   * Previously lived in the deleted `components/Snackbar/Snackbar.scss`.
   * TODO: fold this literal into the accent token during the colour sweep.
   */
  '.snackbar-dismiss-btn': { color: '#fed265' },
  a: {
    textDecoration: 'none',
    color: 'black',
  },
};
